import { GetParentSessionDetailsDTO } from '@shared/clientTypes/DTOs/EnrollmentsDTO';
import {
  GetParentViewCoursesInProgressDTO,
  GetParentViewEnrollmentTimelineDTO,
} from '@shared/clientTypes/DTOs/Parents.DTO';
import { WhatsAppGroupsDTO } from '@shared/clientTypes/DTOs/UserDTO';
import {
  GetParentFeedbackSessionsDTO,
  GetParentViewUpcomingCoursesDTO,
  GetParentViewOverviewFeedbackAvgDTO,
  GetParentViewCompletedCoursesDTO,
  GetParentViewStudentBannerDTO,
  GetParentViewUniversitiesApplyingToDTO,
} from '@shared/clientTypes/DTOs/ParentsDTO';
import {
  ApiDescription,
  ApiData,
  RequestsMethod,
  Student,
  MentorFeedbackItem,
  Enrollment,
  MeetingWithHomework,
} from '../clientTypes';

export const getStudentData: ApiDescription = {
  method: RequestsMethod.Get,
  endpoint: '/parent/student-data',
};

export type GetStudentData = ApiData<
  { userId: string; token: string },
  {
    student: Student;
    enrollments: Enrollment[];
    mentorFeedback: MentorFeedbackItem[];
  }
>;

export const reportParentIssue: ApiDescription = {
  endpoint: '/parent/parent-issue',
  method: RequestsMethod.Post,
};
export type ReportParentIssue = ApiData<any, unknown>;

export const getParentViewCoursesInProgress: ApiDescription = {
  method: RequestsMethod.Get,
  endpoint: '/parent/courses-in-progress',
};

export type GetParentViewCoursesInProgress = ApiData<
  { userId: string; token: string },
  GetParentViewCoursesInProgressDTO
>;

export const getParentViewEnrollmentTimeline: ApiDescription = {
  method: RequestsMethod.Get,
  endpoint: '/parent/enrollment-timeline',
};

export type GetParentViewEnrollmentTimeline = ApiData<
  { userId: string; token: string },
  GetParentViewEnrollmentTimelineDTO
>;

export const feedbackOverview: ApiDescription = {
  endpoint: '/parent/feedback-overview',
  method: RequestsMethod.Get,
};

export type FeedbackOverview = ApiData<
  { userId: string; token: string },
  GetParentViewOverviewFeedbackAvgDTO
>;

export const getStudentBannerDetails: ApiDescription = {
  endpoint: '/parent/student-banner-details',
  method: RequestsMethod.Get,
};

export type GetStudentBannerDetails = ApiData<
  { userId: string; token: string },
  GetParentViewStudentBannerDTO
>;

export const getParentViewUniversitiesApplyingTo: ApiDescription = {
  endpoint: '/parent/universities-applying-to',
  method: RequestsMethod.Get,
};
export type GetParentViewUniversitiesApplyingTo = ApiData<
  { userId: string; token: string },
  GetParentViewUniversitiesApplyingToDTO
>;

export const getParentViewUpcomingCourses: ApiDescription = {
  endpoint: '/parent/upcoming-courses',
  method: RequestsMethod.Get,
};

export type GetParentViewUpcomingCourses = ApiData<
  { userId: string; token: string },
  GetParentViewUpcomingCoursesDTO
>;

export const upcomingStudentMeetings: ApiDescription = {
  endpoint: '/parent/upcoming-student-meetings',
  method: RequestsMethod.Get,
};

export type UpcomingStudentMeetings = ApiData<
  { userId: string; token: string },
  { data: MeetingWithHomework[] }
>;

export const getStudentSessionDetails: ApiDescription = {
  endpoint: '/parent/session-details/:sessionId',
  method: RequestsMethod.Get,
};

export type GetStudentSessionDetails = ApiData<
  { userId: string; token: string },
  GetParentSessionDetailsDTO
>;

export const getParentFeedbackSessions: ApiDescription = {
  endpoint: '/parent/enrollment/:enrollmentId/feedback-sessions',
  method: RequestsMethod.Get,
};

export type GetParentFeedbackSessions = ApiData<
  { userId: string; token: string },
  GetParentFeedbackSessionsDTO
>;

export const getParentViewCompletedCourses: ApiDescription = {
  endpoint: '/parent/completed-courses',
  method: RequestsMethod.Get,
};

export type GetParentViewCompletedCourses = ApiData<
  { userId: string; token: string },
  GetParentViewCompletedCoursesDTO
>;

export const registerParentFeedback: ApiDescription = {
  endpoint: '/parent/register-feedback/:id',
  method: RequestsMethod.Post,
};

export type RegisterParentFeedback = ApiData<
  {
    token: string;
    rating: number;
    message: string;
    userId: string;
  },
  unknown
>;

export const sendParentNewFeedbackPageNotification: ApiDescription = {
  endpoint: '/parent/send-new-feedback-page-notification',
  method: RequestsMethod.Post,
};

export type SendParentNewFeedbackPageNotification = ApiData<unknown, unknown>;

export const getEnrollmentSurveyType: ApiDescription = {
  endpoint: '/parent/get-enrollment-survey-type',
  method: RequestsMethod.Get,
};

export type GetEnrollmentSurveyType = ApiData<
  { token: string; enrollmentId: string; userId: string },
  { surveyType: 'first' | 'intermediate' | 'last' }
>;

export const hasSessionParentFeedback: ApiDescription = {
  endpoint: '/parent/has-session-parent-feedback',
  method: RequestsMethod.Get,
};

export type HasSessionParentFeedback = ApiData<
  { sessionId: string; token: string; userId: string },
  boolean
>;

export const getParentWhatsAppGroups: ApiDescription = {
  method: RequestsMethod.Get,
  endpoint: '/parent/whatsapp-groups',
};

export type GetParentWhatsAppGroups = ApiData<{ userId: string; token: string }, WhatsAppGroupsDTO>;

export const setParentWhatsAppGroupJoined: ApiDescription = {
  method: RequestsMethod.Post,
  endpoint: '/parent/whatsapp-groups/joined',
};

export type SetParentWhatsAppGroupJoined = ApiData<
  { userId: string; token: string; studentId: string; joined: boolean },
  { studentId: string; joined: boolean }
>;

export const dismissParentWhatsAppReminder: ApiDescription = {
  method: RequestsMethod.Post,
  endpoint: '/parent/whatsapp-groups/dismiss',
};

export type DismissParentWhatsAppReminder = ApiData<
  { userId: string; token: string },
  { dismissedAt: string }
>;
